import React from 'react';
import style from './LinkBankingTransparency.module.scss';

export type LinkBankingTransparencyProps = {
  partnerName: string;
  link?: {
    label: string;
    labelLink: string;
    href: string;
    target: string;
  };
  isLogoContext?: boolean;
};

const LinkBankingTransparency = ({
  link,
  partnerName,
  isLogoContext
}: LinkBankingTransparencyProps): React.JSX.Element => {
  const { label, labelLink, href, target } = link || {};

  if (partnerName === 'BNL' && isLogoContext) {
    return (
      <div className={style.textLink}>
        <div>Finanziamenti erogati da Banca AideXa.</div>
        <div>
          Per tutte le informazioni vai alla{' '}
          <a className={style.link} href={href} target={target} rel="noreferrer">
            {labelLink}
          </a>
        </div>
      </div>
    );
  }

  const text = partnerName === 'BNL' ? 'Vai alla ' : label;

  return (
    <div className={style.textLink}>
      {text}{' '}
      <a className={style.link} href={href} target={target} rel="noreferrer">
        {labelLink}
      </a>
    </div>
  );
};

export default LinkBankingTransparency;
